<template>
  <div
    v-if="chips.length > 0"
    class="active-filters col-1-1"
  >
    <UIHoverAnimationButton
      v-for="chip in chips"
      :key="chip.key"
      class="btn btn-secondary flex flex-gap-8"
      icon="close"
      :name="chip.label"
      @click="emit('delete-chip', chip.filter)"
    />
    <UIHoverAnimationButton
      class="btn btn-primary"
      name="Alle filters wissen"
      @click="emit('clear-all')"
    />
  </div>
</template>

<script setup lang="ts">
  import type { FilterOption } from '@tc8l/nuxt-overview'

  defineProps<{
    chips: FilterOption[]
  }>()

  const emit = defineEmits<{
    'delete-chip': [filter: FilterOption]
    'clear-all': []
  }>()
</script>

<style lang="scss" scoped>
  .active-filters {
    display: flex;
    flex-wrap: wrap;
    gap: var(--margin-sm);
  }
</style>
